// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"048a497f","977":"f756512e"}[chunkId] + ".chunk.js";
};